import React, { Component } from 'react';
// import { withCookies } from 'react-cookie';
import SiteSwitcher from './SiteSwitcher'
import Header from './Header'
import Main from './Main'
import CommonStore from './CommonStore';
import { ApolloProvider } from "react-apollo";

class App extends Component {

  // componentDidMount() {
  //   fetch('/version.json')
  //     .then(res => res.json())
  //     .then(data => {
  //       const latestVersion = data.version;
  //       const storedVersion = this.props.cookies.get('app_version');

  //       if (storedVersion !== latestVersion) {
  //         this.props.cookies.set('app_version', latestVersion, { path: '/' });
  //         window.location.reload();
  //       } 
  //     })
  //     .catch(err => console.error('Version check failed:', err));
  // }

    render() {
        const apolloClient = CommonStore.getApolloClient();

    return (
      
        <ApolloProvider client={apolloClient}>
            <SiteSwitcher></SiteSwitcher>
            <Header></Header>      
            <Main></Main>
        </ApolloProvider>

    )
  }
}

export default App;
// export default withCookies(App);
